module.exports = __webpack_public_path__ + "img/menu-outstanding.a8de55c6.svg";